// extracted by mini-css-extract-plugin
module.exports = {"Error":"ErrorBoundary_Error__pVx_A","Logo":"ErrorBoundary_Logo__ETSHr","Header":"ErrorBoundary_Header__KY9MF","Message":"ErrorBoundary_Message__mQeDa"};